@if (session.value(); as session) {
  @if (topic.value(); as topic) {
    <app-show-content
      [session]="session"
      [topic]="topic"
      [stayingPlaces]="stayingPlaces()"
      [subscribedPeople]="subscribedPeople()"
    />
  }
}
